<template>
  <div class="order-detail">
    <div class="detail__header">
      <img
        class="detail__header-img"
        :src="`${imgPrefix}${product.headerImgUrl}`"
      />
      <!-- 周三惠客 -->
      <div v-if="activityCode === 1003" class="detail__header-benefit">
        <div class="detail__header-price">
          <div class="detail__header-orgprice">
            <span>原价：</span>
            <span class="detail__header-orgyuan"
              >{{ fenToYuan(order.originalPrice) }}元</span
            >
          </div>
          <div class="detail__header-curprice">
            秒杀价：{{ fenToYuan(order.productPrice) }}元
          </div>
        </div>
      </div>
    </div>
    <div class="detail__base">
      <div class="detail__base-title">{{ product.name }}</div>
      <div class="detail__base-content">兑换时间：{{ order.orderTime }}</div>
      <div class="detail__base-content">
        兑换有效期至：{{ order.expireTime }}
      </div>
    </div>
    <div v-if="order.status === 1" class="detail__card detail__card--wxpay">
      <div class="detail__card-row">
        <div class="detail__card-label">状态：</div>
        <div class="detail__card-text">待支付</div>
        <div class="detail__card-btn__cancel" @click="onCancelPay">
          取消支付
        </div>
        <div class="detail__card-btn" @click="onPay">支付</div>
      </div>
    </div>
    <div v-if="order.status === 7" class="detail__card detail__card--wxpay">
      <div class="detail__card-row">
        <div class="detail__card-label">状态：</div>
        <div class="detail__card-text">已取消</div>
      </div>
    </div>

    <!-- 卡密权益且已支付 -->
    <template
      v-if="
        product.productType === 1 &&
        (order.status === 2 ||
          order.status === 3 ||
          order.status === 4 ||
          order.status === 5)
      "
    >
      <div v-if="order.cardNo.length > 0" class="detail__card">
        <template v-if="order.cardPwd && order.status === 4">
          <div class="detail__card-row">
            <div class="detail__card-label">卡号：</div>
            <input class="detail__card-input" v-model="order.cardNo" disabled />
            <div class="detail__card-btn" @click="onCopy(order.cardNo)">
              复制
            </div>
          </div>
          <div class="detail__card-row">
            <div class="detail__card-label">卡密：</div>
            <input
              class="detail__card-input"
              v-model="order.cardPwd"
              disabled
            />
            <div class="detail__card-btn" @click="onCopy(order.cardPwd)">
              复制
            </div>
          </div>
        </template>
        <template v-else>
          <div class="detail__card-row detail__card-row--getting">
            <div class="detail__card-label">卡密：</div>
            <div class="detail__card--getting">提码中</div>
          </div>
        </template>
      </div>
      <div v-else  class="detail__card">
        <div class="detail__link">
          <div class="detail__link-label">卡密：</div>
          <template v-if="order.cardPwd && order.status === 4">
            <input class="detail__link-input" v-model="order.cardPwd" disabled />
            <div class="detail__link-btn" @click="onCopy(order.cardPwd)">
              复制
            </div>
            
          </template>
          <template v-else>
            <div class="detail__card--getting">提码中</div>
          </template>
        </div>
       
        <div v-if="product.id === 28" class="detail__card-btn detail__card-btn__wechat" @click="onGetWechatCoupon(order.cardPwd)">去领取</div>
      </div>
      
    </template>
    <!-- 直充权益且已支付 -->
    <template
      v-else-if="
        product.productType === 2 &&
        (order.status === 2 ||
          order.status === 3 ||
          order.status === 4 ||
          order.status === 5)
      "
    >
      <div v-if="order.status === 2" class="detail__form">
        <div class="detail__form-row">
          <div class="detail__form-label">手机号：</div>
          <input
            class="detail__form-input"
            pattern="[0-9]*"
            type="tel"
            placeholder="请输入手机号"
            v-model="mobile"
            @input="onMobileInput"
          />
        </div>
        <div class="detail__form-row">
          <div class="detail__form-label">验证码：</div>
          <input
            class="detail__form-input"
            pattern="[0-9]*"
            type="tel"
            placeholder="请输入验证码"
            v-model="verifyCode"
            @input="onVerifyCodeInput"
          />
          <div
            :class="
              countDown > 0
                ? 'detail__form-btn-verify__disabled'
                : 'detail__form-btn-verify'
            "
            @click="onSendVerifyCode(mobile, product.id)"
          >
            {{ countDown > 0 ? `重新发送(${countDown}s)` : '获取验证码' }}
          </div>
        </div>
        <div class="detail__form-btn" @click="onSubmit">确定</div>
      </div>
      <div
        v-else-if="order.status === 3 || order.status === 5"
        class="detail__card--text"
      >
        充值中
      </div>
      <div v-else-if="order.status === 4" class="detail__card--text">
        {{ `充值账号：${order.rechargeAccount}` }}
      </div>
    </template>
    <div class="detail__content">
      <div class="detail__content-title">{{ product.name }}</div>
      <div class="detail__content-text" v-html="product.description"></div>
    </div>

    <van-dialog
      v-model:show="isExchangePopupVisble"
      @confirm="onConfirmExchange"
    >
      <div class="exchange-popup">
        <img class="popup__icon" src="../../assets/success-icon.png" />
        <div class="popup__title">已兑换完成</div>
        <div class="popup__text">点击我的-兑换记录-可查询兑换商品</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, toRef } from 'vue'
import { Dialog, Toast } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { formateDate } from '@/utils'
import api from '@/api'
import globalVariables from '@/utils/globalVariables'
import wx from 'weixin-js-sdk'
import { isInWxBrowser } from '@/utils/wechatUtil'
import useWechat from '@/utils/useWechat'
import { fenToYuan } from '@/utils'
import useVerify from './hooks/useVerify'
import useCopy from './hooks/useCopy'

export default {
  setup() {
    const router = useRouter()
    const route = useRoute()
    let { orderCode } = route.query

    const { state } = useWechat(orderCode)

    if (state) {
      orderCode = state
    }

    onMounted(async () => {
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      const res = await api.getOrderDetail({
        orderCode
      })

      Toast.clear()
      data.activityCode = res.data.activityCode
      data.order = {
        orderId: res.data.orderId,
        orderCode: res.data.orderCode,
        orderTime: formateDate(res.data.orderTime),
        expireTime: formateDate(res.data.expireTime),
        status: res.data.status,
        rechargeAccount: res.data.rechargeAccount,
        cardNo:
          res.data.cardPwd.indexOf(',') > -1 ||
          res.data.cardPwd.indexOf('，') > -1
            ? res.data.cardPwd.split(/[,，]/)[0].trim()
            : '',
        cardPwd:
          res.data.cardPwd.indexOf(',') > -1 ||
          res.data.cardPwd.indexOf('，') > -1
            ? res.data.cardPwd.split(/[,，]/)[1].trim()
            : res.data.cardPwd.trim(),
        originalPrice: res.data.originalPrice,
        productPrice: res.data.productPrice
      }
      data.product = res.data.productDTO

      // 待支付
      if (data.order.status === 1 && globalVariables.isFromProductDetailPage) {
        globalVariables.isFromProductDetailPage = false
        onPay()
      }
    })

    const data = reactive({
      activityCode: 0,
      order: {
        orderCode: '',
        cardNo: '',
        cardPwd: '',
        originalPrice: 0,
        productPrice: 0
      },
      product: {
        id: -1,
        name: '',
        thumbnailUrl: '',
        headerImgUrl: '',
        detailImgUrl: '',
        productType: 1,
        description: ''
      },
      mobile: '',
      verifyCode: '',
      isExchangePopupVisble: false
    })

    const { countDown, onSendVerifyCode } = useVerify()
    const { copy } = useCopy()

    const onMobileInput = e => {
      if (e.target.value.length > 11)
        data.mobile = data.mobile.toString().slice(0, 11)
    }

    const onVerifyCodeInput = e => {
      if (e.target.value.length > 6)
        data.verifyCode = e.target.value.slice(0, 6)
    }

    const onPay = async () => {
      if (!isInWxBrowser()) {
        Toast.fail('请在微信中打开, 否则无法支付')
        return
      }

      Toast.loading({
        duration: 0,
        forbidClick: true
      })

      const { order } = data
      const payRes = await api.wxPrePay({
        orderId: order.orderId,
        orderCode: order.orderCode,
        openId: globalVariables.getOpenid(),
        totalFee: order.productPrice
      })
      Toast.clear()
      if (payRes.error) {
        Toast.fail(payRes.error.message)
        return
      }

      const { appId, timeStamp, nonceStr, prepayId, signType, paySign } =
        payRes.data

      if (!globalVariables.signature) {
        const wxSignRes = await api.getWxSignature({
          clientKey: globalVariables.clientKey,
          timestamp: timeStamp,
          nonceStr: nonceStr,
          url: encodeURIComponent(location.href)
        })
        globalVariables.signature = wxSignRes.data.signature
      }

      new Promise((resolve, reject) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId, // 必填，公众号的唯一标识
          timestamp: timeStamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature: globalVariables.signature, // 必填，签名
          jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
        })
        wx.ready(() => {
          resolve()
        })
        wx.error(res => {
          reject(res)
        })
      }).then(() => {
        wx.chooseWXPay({
          timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr, // 支付签名随机串，不长于 32 位
          package: 'prepay_id=' + prepayId, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign, // 支付签名
          success: function () {
            Toast.success('支付成功')
            router.replace({
              path: '/orderDetail',
              query: {
                orderCode: order.orderCode
              }
            })
            setTimeout(() => {
              history.go(0)
            }, 0)
          },
          fail: function () {
            Toast.fail('支付失败')
          }
        })
      })
    }

    const onCancelPay = () => {
      Dialog.confirm({
        title: '确认取消支付',
        message: data.product.name
      }).then(async () => {
        Toast.loading({
          duration: 0,
          forbidClick: true
        })
        const res = await api.cancelPay({
          orderCode
        })
        if (res.error) {
          Toast.fail(res.error.message)
          return
        }
        Toast.clear()
        Toast.success('取消成功')
        router.push({
          path: '/homeForPersonal'
        })
      })
    }

    const onSubmit = async () => {
      if (!data.mobile) {
        Toast('请输入手机号')
        return
      }
      if (!data.verifyCode) {
        Toast('请输入验证码')
        return
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(data.mobile)) {
        Toast('请填写正确的手机号码')
        return
      }
      if (data.verifyCode.toString().length > 6) {
        Toast('请输入正确位数的验证码')
        return
      }

      Toast.loading({
        duration: 0,
        forbidClick: true
      })
      const res = await api.recharge({
        account: data.mobile,
        orderCode: data.order.orderCode,
        productCode: data.product.productCode,
        productId: data.product.id,
        verifyCode: data.verifyCode
      })
      if (res.error) {
        Toast.clear()
        Toast(res.error.message)
        return
      }
      Toast.clear()
      data.isExchangePopupVisble = true
    }

    const onCopy = text => {
      copy(text)
    }

    const onConfirmExchange = () => {
      router.push({ path: '/' })
    }

    const onGetWechatCoupon = (text) => {
      if (data.order.status !== 4) {
        Toast('提码中，请稍后领取')
        return
      }
     
      copy(text)
      location.href = 'https://admin.ue-link.com/web/wxcoupon/home'
    }

    return {
      imgPrefix: globalVariables.imgPrefix,
      activityCode: toRef(data, 'activityCode'),
      product: toRef(data, 'product'),
      order: toRef(data, 'order'),
      mobile: toRef(data, 'mobile'),
      verifyCode: toRef(data, 'verifyCode'),
      isExchangePopupVisble: toRef(data, 'isExchangePopupVisble'),
      countDown,
      fenToYuan,
      onMobileInput,
      onVerifyCodeInput,
      onSendVerifyCode,
      onSubmit,
      onCopy,
      onConfirmExchange,
      onCancelPay,
      onPay,
      onGetWechatCoupon
    }
  }
}
</script>


<style lang="less" scoped="scoped">
.order-detail {
  min-height: 100vh;
  background: #f5f5f5;
  .detail__header {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 19px;
    .detail__header-img {
      width: 229px;
      height: 148px;
      margin-top: 21px;
    }

    .detail__header-benefit {
      display: flex;
      width: 375px;
      margin-top: 11px;
      align-items: flex-end;
      .detail__header-price {
        margin-left: 36px;
        flex: 1;
        .detail__header-orgprice {
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;

          color: #333333;
          .detail__header-orgyuan {
            text-decoration: line-through;
          }
        }
        .detail__header-curprice {
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #d80c18;
          margin-top: 8px;
        }
      }
    }
  }
  .detail__base {
    background: #ffffff;
    border-radius: 8px;
    width: 349px;
    margin: 8px 13px;
    padding-bottom: 15px;
    overflow: hidden;
    .detail__base-title {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
      margin-left: 13px;
      margin-bottom: 10px;
    }
    .detail__base-content {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-top: 7px;
      margin-left: 13px;
    }
  }
  .detail__form {
    background: #ffffff;
    border-radius: 8px;
    width: 349px;
    margin: 8px 13px;
    overflow: hidden;
    padding-bottom: 15px;
    .detail__form-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 15px;
      margin-left: 13px;
      margin-bottom: 10px;
      .detail__form-label {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #121212;
        min-width: 60px;
      }
      .detail__form-input {
        width: 158px;
        height: 29px;
        background: #f2f2f2;
        border: 1px solid #cccccc;
        border-radius: 5px;
        padding-left: 10px;

        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
      .detail__form-btn-verify {
        width: 86px;
        height: 29px;
        border: 1px solid #ff0000;
        border-radius: 14px;

        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        text-align: center;

        margin-left: 8px;
      }
      .detail__form-btn-verify:active {
        opacity: 0.8;
      }
      .detail__form-btn-verify__disabled {
        width: 86px;
        height: 29px;
        border: 1px solid #ff0000;
        border-radius: 14px;

        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        text-align: center;

        margin-left: 8px;
      }
      .detail__form-btn-verify__disabled:active {
        opacity: 0.8;
      }
    }
    .detail__form-btn {
      width: 104px;
      height: 30px;
      background: #d80c18;
      border-radius: 15px;

      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;

      margin-top: 13px;
      margin-left: 121px;
    }
    .detail__form-btn:active {
      opacity: 0.8;
    }
  }
  .detail__link {
    margin: 13px 0 0 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    .detail__link-label {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #121212;
      min-width: 60px;
      text-align: right;
    }
    .detail__link-input {
      width: 158px;
      height: 29px;
      background: #f2f2f2;
      border: 1px solid #cccccc;
      border-radius: 5px;
      padding-left: 10px;

      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
    .detail__link-btn {
      width: 86px;
      height: 30px;
      background: #d80c18;
      border-radius: 15px;

      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;

      margin-left: 10px;
    }
    .detail__link-btn:active {
      opacity: 0.8;
    }
  }
  .detail__card {
    background: #ffffff;
    border-radius: 8px;
    width: 349px;
    margin: 8px 13px;
    overflow: hidden;
    padding-bottom: 15px;
    .detail__card-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 15px;
      margin-bottom: 10px;
      .detail__card-label {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #121212;
        min-width: 60px;
        text-align: right;
      }
      .detail__card-text {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #121212;
        width: 92px;
      }
    }
    .detail__card-input {
      width: 158px;
      height: 29px;
      background: #f2f2f2;
      border: 1px solid #cccccc;
      border-radius: 5px;
      padding-left: 10px;

      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
    .detail__card-btn {
      width: 86px;
      height: 30px;
      background: #d80c18;
      border-radius: 15px;

      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;

      margin-left: 10px;
    }
    .detail__card-btn:active {
      opacity: 0.8;
    }
    .detail__card-btn__cancel {
      width: 84px;
      height: 28px;
      border: 1px solid #d80c18;
      border-radius: 14px;

      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
    }
    .detail__card-btn__cancel:active {
      opacity: 0.8;
    }
    .detail__card-btn__wechat {
      margin-left: 140px;
      margin-top: 10px;
    }
  }
  .detail__card--text {
    background: #ffffff;
    border-radius: 8px;
    width: 349px;
    margin: 8px 13px;
    overflow: hidden;
    padding: 15px 0 15px 15px;

    display: flex;
    flex-direction: row;
    align-items: center;

    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121212;
  }
  .detail__card--wxpay {
    padding-bottom: 5px;
  }
  .detail__card-row--getting {
    padding-top: 10px;
  }
  .detail__card--getting {
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121212;
    min-width: 60px;
  }
  .detail__content {
    background: #ffffff;
    border-radius: 8px;
    width: 349px;
    margin: 8px 13px;
    overflow: hidden;
    .detail__content-title {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 15px;
    }
    .detail__content-text {
      margin: 13px 8px;
      padding: 4px 8px;
      font-size: 12px;
      line-height: 22px;
      white-space: pre-wrap;
      letter-spacing: 1px;
    }
  }

  .exchange-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 14px;
    .popup__icon {
      width: 59px;
      height: 59px;
      margin-top: 47px;
    }
    .popup__title {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #121212;
      margin-top: 11px;
    }
    .popup__text {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      margin-top: 11px;
    }
  }
}
</style>

<style lang="less" >
.detail__content-text h1 {
  font-size: 14px;
  line-height: 24px;
  margin: 0;
  padding: 0;
}
</style>